import React, { useState } from 'react';
import "./AdminMenu.css";
import { Link, useLocation } from "react-router-dom"
import { useAuth } from "../../../../hooks";
import LogoK from "../../../../assets/svg/KAAPA_Logo-Negativo-K.svg"
import LogoKaapa from "../../../../assets/svg/KAAPA_Logo-Negativo.svg"
import { ChevronDown, ChevronUp, User, Plus, List, Newspaper, Users, Wrench, FileText, FlaskConical, DollarSign, LogOut, } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { ENV } from "../../../../utils";
import { image } from "../../../../assets";

export function AdminMenu({ onToggle }) {
  const { pathname } = useLocation();
  const { user: { role } } = useAuth();
  const isAdmin = role === "admin";
  const isIyd = role === "iyd";
  const isOpe = role === "ope";
  const isCom = role === "com";
  const isAse = role === "user";
  const isConta = role === "conta";
  const isSist = role === "sistemas";
  const isMarket = role === "marketing";
  const isAtencion = role === "atencion";
  const isBioequal = role === "bioequal";
  const isMagi = role === "magi";
  const isBioelite = role === "bioelite";
  const isFN = role === "fn";
  const navigate = useNavigate();
  const { logout, user: { avatar, firstname, lastname } } = useAuth();
  const Nombre = firstname;
  const Apellido = lastname;
  //
  const isCurrentPath = (path) => {
    if (path === pathname) return true;
    return false;
  }

  const [openDropdowns, setOpenDropdowns] = useState({});
  //
  const toggleDropdown = (id) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const isOpen = (id) => openDropdowns[id] || false;

  const onLogout = () => {
    logout();
    navigate("/");
  };

  const onPerfil = () => {
    navigate("/admin/perfil");
  };

  const imagenUrl = avatar ? `${ENV.USUSARIOS}/${avatar}` : image.noAvatar;

  return (
    <>
      <div className='sidebarH'>
        <Link onClick={onToggle} to="/admin/Princ" >
          <div className='logo-datails'>
            <img src={LogoKaapa} className='logoKaapa' alt="KAAPA Logo" />
          </div>
        </Link>
        <ul className='nav-links'>
          {isAdmin && (
            <>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('admin')} className='link-item'>
                    <span className='link_name'>Administrador</span>
                    {isOpen('admin') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('admin') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/users" className={isCurrentPath("/admin/users") ? "active" : ""}>
                          <User size={18} />
                          <span>Usuarios</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/menu" className={isCurrentPath("/admin/menu") ? "active" : ""}>
                          <Plus size={18} />
                          <span>Menu</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/courses" className={isCurrentPath("/admin/courses") ? "active" : ""}>
                          <List size={18} />
                          <span>Enlaces</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/newsletter" className={isCurrentPath("/admin/newsletter") ? "active" : ""}>
                          <Newspaper size={18} />
                          <span>Noticias</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/blog" className={isCurrentPath("/admin/blog") ? "active" : ""}>
                          <Users size={18} />
                          <span>Blog</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('soporte')} className='link-item'>
                    <span className='link_name'>Ticket de Soporte</span>
                    {isOpen('soporte') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('soporte') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <a href="https://forms.office.com/pages/responsepage.aspx?id=pRffhtXT0kuFU3sNV6O3PBUZyAc4Wx5EiTVlITBFysBUNTRUM0QyRUszN1pSSUFTRlk5WEpIVklBMC4u" target="_blank" rel="noopener noreferrer">
                          <Wrench size={18} />
                          <span>Tickets de Soporte</span>
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('soporte2')} className='link-item'>
                    <span className='link_name'>Ticket 2 Soporte</span>
                    {isOpen('soporte2') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('soporte2') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/soporte" className={isCurrentPath("/admin/soporte") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('investigacion')} className='link-item'>
                    <span className='link_name'>Investigación y Desarrollo</span>
                    {isOpen('investigacion') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('investigacion') && (
                    <ul className='dropdown-menu'>

                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('derma') }} className='link-item'>
                            <span>Derma</span>
                            {isOpen('derma') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('derma') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/inyde" className={isCurrentPath("/admin/inyde") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Solicitud Nueva Formula</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/inydes" className={isCurrentPath("/admin/inydes") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Solicitud Nueva Presentación</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/inydess" className={isCurrentPath("/admin/inydess") ? "active" : ""}>
                                  <FlaskConical size={16} />
                                  <span>Cambio de Base</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>

                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('bioequal-inv') }} className='link-item'>
                            <span>Bioequal</span>
                            {isOpen('bioequal-inv') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('bioequal-inv') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioequal/asesor" className={isCurrentPath("/admin/bioequal/asesor") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Generar Cotización Bioequal Nueva</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioequal/inyde" className={isCurrentPath("/admin/bioequal/inyde") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización Bioequal Nueva</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioequal/ope" className={isCurrentPath("/admin/bioequal/ope") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización (Ope) Bioequal Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>

                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('bioelite-inv') }} className='link-item'>
                            <span>Bioelite</span>
                            {isOpen('bioelite-inv') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('bioelite-inv') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioelite/asesor" className={isCurrentPath("/admin/bioelite/asesor") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Generar Cotización Bioelite Nueva</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioelite/inyde" className={isCurrentPath("/admin/bioelite/inyde") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización Bioelite Nueva</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioelite/ope" className={isCurrentPath("/admin/bioelite/ope") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización (Ope) Bioelite Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>

                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('reve-inv') }} className='link-item'>
                            <span>Reve</span>
                            {isOpen('reve-inv') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('reve-inv') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/reve/asesor" className={isCurrentPath("/admin/reve/asesor") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Generar Cotización Reve Nueva</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/reve/ope" className={isCurrentPath("/admin/reve/ope") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Generar Cotización Reve Nueva (Ope)</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/reve/inyde" className={isCurrentPath("/admin/reve/inyde") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Solicitud nuevo producto (inyde)</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>

                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('dz-inv') }} className='link-item'>
                            <span>DZ</span>
                            {isOpen('dz-inv') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('dz-inv') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/dz/asesor" className={isCurrentPath("/admin/dz/asesor") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Generar Cotización DZ Nueva</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/dz/ope" className={isCurrentPath("/admin/dz/ope") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Generar Cotización DZ Nueva (Ope)</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/dz/inyde" className={isCurrentPath("/admin/dz/inyde") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Solicitud Nueva Formula(inyde)</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('operaciones')} className='link-item'>
                    <span className='link_name'>Operaciones</span>
                    {isOpen('operaciones') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('operaciones') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/ope" className={isCurrentPath("/admin/ope") ? "active" : ""}>
                          <FileText size={18} />
                          <span>Cotización Magistral Derma Nueva</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/opes" className={isCurrentPath("/admin/opes") ? "active" : ""}>
                          <FlaskConical size={18} />
                          <span>Cotización de Nueva Presentación</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/opess" className={isCurrentPath("/admin/opess") ? "active" : ""}>
                          <FlaskConical size={18} />
                          <span>Cotización de Cambio de Base</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('comercial')} className='link-item'>
                    <span className='link_name'>Gestión Comercial</span>
                    {isOpen('comercial') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('comercial') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/gestioncomercial" className={isCurrentPath("/admin/gestioncomercial") ? "active" : ""}>
                          <FileText size={18} />
                          <span>Cotización Magistral Derma Nueva</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/gestioncomercials" className={isCurrentPath("/admin/gestioncomercials") ? "active" : ""}>
                          <FlaskConical size={18} />
                          <span>Cotización de Nueva Presentación</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/gestioncomercialss" className={isCurrentPath("/admin/gestioncomercialss") ? "active" : ""}>
                          <FlaskConical size={18} />
                          <span>Cotización de Cambio de Base</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('contabilidad')} className='link-item'>
                    <span className='link_name'>Contabilidad</span>
                    {isOpen('contabilidad') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('contabilidad') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/omicronshoppagos" className={isCurrentPath("/admin/omicronshoppagos") ? "active" : ""}>
                          <DollarSign size={18} />
                          <span>Pagos de OmicronShop</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/transaccionescredito" className={isCurrentPath("/admin/transaccionescredito") ? "active" : ""}>
                          <DollarSign size={18} />
                          <span>Transacciones de Crédito</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/clientescreditos" className={isCurrentPath("/admin/clientescreditos") ? "active" : ""}>
                          <DollarSign size={18} />
                          <span>Clientes con Crédito</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/facturapagas" className={isCurrentPath("/admin/facturapagas") ? "active" : ""}>
                          <FileText size={18} />
                          <span>Facturas pagadas</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('soporte3')} className='link-item'>
                    <span className='link_name'>Ticket de Soporte</span>
                    {isOpen('soporte3') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('soporte3') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <a href="https://forms.office.com/pages/responsepage.aspx?id=pRffhtXT0kuFU3sNV6O3PBUZyAc4Wx5EiTVlITBFysBUNTRUM0QyRUszN1pSSUFTRlk5WEpIVklBMC4u" target="_blank" rel="noopener noreferrer">
                          <Wrench size={18} />
                          <span>Tickets de Soporte</span>
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('altaCliente')} className='link-item'>
                    <span className='link_name'>Alta Cliente</span>
                    {isOpen('altaCliente') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('altaCliente') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/altaclientes" className={isCurrentPath("/admin/altaclientes") ? "active" : ""}>
                          <FileText size={18} />
                          <span>Alta de clientes</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/altaclientescome" className={isCurrentPath("/admin/altaclientescome") ? "active" : ""}>
                          <FileText size={18} />
                          <span>Alta de clientes</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('gestionFormulas')} className='link-item'>
                    <span className='link_name'>Gestión para Fórmulas</span>
                    {isOpen('gestionFormulas') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('gestionFormulas') && (
                    <ul className='dropdown-menu'>

                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('formDerma') }} className='link-item'>
                            <span>Derma</span>
                            {isOpen('formDerma') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('formDerma') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/asesor" className={isCurrentPath("/admin/asesor") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Generar Cotización Magistral Derma Nueva</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/presentacion" className={isCurrentPath("/admin/presentacion") ? "active" : ""}>
                                  <FlaskConical size={16} />
                                  <span>Generar Cotización de Nueva Presentación</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/cambiobase" className={isCurrentPath("/admin/cambiobase") ? "active" : ""}>
                                  <FlaskConical size={16} />
                                  <span>Generar Cotización de Cambio de Base</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>

                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('formBioequal') }} className='link-item'>
                            <span>Bioequal</span>
                            {isOpen('formBioequal') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('formBioequal') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioequal/asesor" className={isCurrentPath("/admin/bioequal/asesor") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Generar Cotización Bioequal Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('marketing-ase')} className='link-item'>
                    <span className='link_name'>Ticket de Marketing</span>
                    {isOpen('marketing-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('marketing-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing" className={isCurrentPath("/admin/asesor/marketing") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Diseño</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing/eventos" className={isCurrentPath("/admin/asesor/marketing/eventos") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Material (eventos)</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

            </>
          )}

          {isSist && (
            <>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('admin-sist')} className='link-item'>
                    <span className='link_name'>Administrador</span>
                    {isOpen('admin-sist') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('admin-sist') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/menu" className={isCurrentPath("/admin/menu") ? "active" : ""}>
                          <Plus size={18} />
                          <span>Menu</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/users" className={isCurrentPath("/admin/users") ? "active" : ""}>
                          <User size={18} />
                          <span>Usuarios</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/courses" className={isCurrentPath("/admin/courses") ? "active" : ""}>
                          <List size={18} />
                          <span>Enlaces</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/newsletter" className={isCurrentPath("/admin/newsletter") ? "active" : ""}>
                          <Newspaper size={18} />
                          <span>Noticias</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/blog" className={isCurrentPath("/admin/blog") ? "active" : ""}>
                          <Users size={18} />
                          <span>Blog</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('soporte-sist')} className='link-item'>
                    <span className='link_name'>Ticket de Soporte</span>
                    {isOpen('soporte-sist') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('soporte-sist') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <a href="https://forms.office.com/pages/responsepage.aspx?id=pRffhtXT0kuFU3sNV6O3PBUZyAc4Wx5EiTVlITBFysBUNTRUM0QyRUszN1pSSUFTRlk5WEpIVklBMC4u" target="_blank" rel="noopener noreferrer">
                          <Wrench size={18} />
                          <span>Tickets de Soporte</span>
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('soporte2-sist')} className='link-item'>
                    <span className='link_name'>Ticket 2 Soporte</span>
                    {isOpen('soporte2-sist') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('soporte2-sist') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/soporte" className={isCurrentPath("/admin/soporte") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('marketing-ase')} className='link-item'>
                    <span className='link_name'>Ticket de Marketing</span>
                    {isOpen('marketing-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('marketing-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing" className={isCurrentPath("/admin/asesor/marketing") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Diseño</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing/eventos" className={isCurrentPath("/admin/asesor/marketing/eventos") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Material (eventos)</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

            </>
          )}

          {isIyd && (
            <>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('gestion-iyd')} className='link-item'>
                    <span className='link_name'>Gestión para Formulas</span>
                    {isOpen('gestion-iyd') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('gestion-iyd') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('derma-iyd') }} className='link-item'>
                            <span>Derma</span>
                            {isOpen('derma-iyd') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('derma-iyd') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/inyde" className={isCurrentPath("/admin/inyde") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Solicitud Nueva Formula</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/inydess" className={isCurrentPath("/admin/inydess") ? "active" : ""}>
                                  <FlaskConical size={16} />
                                  <span>Cambio de Base</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('reve-iyd') }} className='link-item'>
                            <span>Reve</span>
                            {isOpen('reve-iyd') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('reve-iyd') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/reve/inyde" className={isCurrentPath("/admin/reve/inyde") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Solicitud Nuevo Producto</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('dz-iyd') }} className='link-item'>
                            <span>DZ</span>
                            {isOpen('dz-iyd') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('dz-iyd') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/dz/inyde" className={isCurrentPath("/admin/dz/inyde") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Solicitud Nueva Formula</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('soporte-iyd')} className='link-item'>
                    <span className='link_name'>Ticket de Soporte</span>
                    {isOpen('soporte-iyd') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('soporte-iyd') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <a href="https://forms.office.com/pages/responsepage.aspx?id=pRffhtXT0kuFU3sNV6O3PBUZyAc4Wx5EiTVlITBFysBUNTRUM0QyRUszN1pSSUFTRlk5WEpIVklBMC4u" target="_blank" rel="noopener noreferrer">
                          <Wrench size={18} />
                          <span>Tickets de Soporte</span>
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('marketing-ase')} className='link-item'>
                    <span className='link_name'>Ticket de Marketing</span>
                    {isOpen('marketing-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('marketing-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing" className={isCurrentPath("/admin/asesor/marketing") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Diseño</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing/eventos" className={isCurrentPath("/admin/asesor/marketing/eventos") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Material (eventos)</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

            </>
          )}

          {isMagi && (
            <>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('gestion-magi')} className='link-item'>
                    <span className='link_name'>Gestión para Formulas</span>
                    {isOpen('gestion-magi') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('gestion-magi') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('derma-magi') }} className='link-item'>
                            <span>Derma</span>
                            {isOpen('derma-magi') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('derma-magi') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/inyde" className={isCurrentPath("/admin/inyde") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización Magistral Derma Nueva</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/inydess" className={isCurrentPath("/admin/inydess") ? "active" : ""}>
                                  <FlaskConical size={16} />
                                  <span>Cotización de Cambio de Base</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('bioequal-magi') }} className='link-item'>
                            <span>Bioequal</span>
                            {isOpen('bioequal-magi') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('bioequal-magi') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioequal/inyde" className={isCurrentPath("/admin/bioequal/inyde") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización Bioequal Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('bioelite-magi') }} className='link-item'>
                            <span>Bioelite</span>
                            {isOpen('bioelite-magi') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('bioelite-magi') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioelite/inyde" className={isCurrentPath("/admin/bioelite/inyde") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización Bioelite Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('reve-magi') }} className='link-item'>
                            <span>Reve</span>
                            {isOpen('reve-magi') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('reve-magi') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/reve/inyde" className={isCurrentPath("/admin/reve/inyde") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización Reve Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('dz-magi') }} className='link-item'>
                            <span>DZ</span>
                            {isOpen('dz-magi') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('dz-magi') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/dz/inyde" className={isCurrentPath("/admin/dz/inyde") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización DZ Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('soporte-magi')} className='link-item'>
                    <span className='link_name'>Ticket de Soporte</span>
                    {isOpen('soporte-magi') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('soporte-magi') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <a href="https://forms.office.com/pages/responsepage.aspx?id=pRffhtXT0kuFU3sNV6O3PBUZyAc4Wx5EiTVlITBFysBUNTRUM0QyRUszN1pSSUFTRlk5WEpIVklBMC4u" target="_blank" rel="noopener noreferrer">
                          <Wrench size={18} />
                          <span>Tickets de Soporte</span>
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('marketing-ase')} className='link-item'>
                    <span className='link_name'>Ticket de Marketing</span>
                    {isOpen('marketing-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('marketing-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing" className={isCurrentPath("/admin/asesor/marketing") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Diseño</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing/eventos" className={isCurrentPath("/admin/asesor/marketing/eventos") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Material (eventos)</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

            </>
          )}

          {isBioequal && (
            <>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('gestion-bioequal')} className='link-item'>
                    <span className='link_name'>Gestión para Formulas</span>
                    {isOpen('gestion-bioequal') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('gestion-bioequal') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('bioequal-bio') }} className='link-item'>
                            <span>Bioequal</span>
                            {isOpen('bioequal-bio') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('bioequal-bio') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioequal/inyde" className={isCurrentPath("/admin/bioequal/inyde") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización Bioequal Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('soporte-bioequal')} className='link-item'>
                    <span className='link_name'>Ticket de Soporte</span>
                    {isOpen('soporte-bioequal') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('soporte-bioequal') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <a href="https://forms.office.com/pages/responsepage.aspx?id=pRffhtXT0kuFU3sNV6O3PBUZyAc4Wx5EiTVlITBFysBUNTRUM0QyRUszN1pSSUFTRlk5WEpIVklBMC4u" target="_blank" rel="noopener noreferrer">
                          <Wrench size={18} />
                          <span>Tickets de Soporte</span>
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('marketing-ase')} className='link-item'>
                    <span className='link_name'>Ticket de Marketing</span>
                    {isOpen('marketing-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('marketing-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing" className={isCurrentPath("/admin/asesor/marketing") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Diseño</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing/eventos" className={isCurrentPath("/admin/asesor/marketing/eventos") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Material (eventos)</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              {/* 
              <li>
                <div className='dropdown' >
                  <div className='link-item' onClick={() => toggleDropdown('alta-ase')}>
                    <span className='link_name'>Alta Cliente</span>
                    {isOpen('alta-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('alta-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/altaclientes" className={isCurrentPath("/admin/altaclientes") ? "active" : ""}>
                          <FileText size={18} />
                          <span>Alta de clientes</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>*/}

            </>
          )}

          {isBioelite && (
            <>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('gestion-bioelite')} className='link-item'>
                    <span className='link_name'>Gestión para Formulas</span>
                    {isOpen('gestion-bioelite') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('gestion-bioelite') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('bioelite-bio') }} className='link-item'>
                            <span>Bioelite</span>
                            {isOpen('bioelite-bio') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('bioelite-bio') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioelite/inyde" className={isCurrentPath("/admin/bioelite/inyde") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización Bioelite Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('soporte-bioelite')} className='link-item'>
                    <span className='link_name'>Ticket de Soporte</span>
                    {isOpen('soporte-bioelite') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('soporte-bioelite') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <a href="https://forms.office.com/pages/responsepage.aspx?id=pRffhtXT0kuFU3sNV6O3PBUZyAc4Wx5EiTVlITBFysBUNTRUM0QyRUszN1pSSUFTRlk5WEpIVklBMC4u" target="_blank" rel="noopener noreferrer">
                          <Wrench size={18} />
                          <span>Tickets de Soporte</span>
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('marketing-ase')} className='link-item'>
                    <span className='link_name'>Ticket de Marketing</span>
                    {isOpen('marketing-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('marketing-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing" className={isCurrentPath("/admin/asesor/marketing") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Diseño</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing/eventos" className={isCurrentPath("/admin/asesor/marketing/eventos") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Material (eventos)</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

            </>
          )}

          {isOpe && (
            <>
              <li>
                <div className='dropdown' id="ope_gestion">
                  <div onClick={() => toggleDropdown('gestion-ope')} className='link-item'>
                    <span className='link_name'>Gestión para Formulas</span>
                    {isOpen('gestion-ope') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('gestion-ope') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('derma-ope') }} className='link-item'>
                            <span>Derma</span>
                            {isOpen('derma-ope') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('derma-ope') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/ope" className={isCurrentPath("/admin/ope") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización Magistral Derma Nueva</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/opes" className={isCurrentPath("/admin/opes") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización Magistral Derma Presentación</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/opess" className={isCurrentPath("/admin/opess") ? "active" : ""}>
                                  <FlaskConical size={16} />
                                  <span>Cotización de Cambio de Base</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('bioequal-ope') }} className='link-item'>
                            <span>Bioequal</span>
                            {isOpen('bioequal-ope') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('bioequal-ope') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioequal/ope" className={isCurrentPath("/admin/bioequal/ope") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización (Ope) Bioequal Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('bioelite-ope') }} className='link-item'>
                            <span>Bioelite</span>
                            {isOpen('bioelite-ope') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('bioelite-ope') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioelite/ope" className={isCurrentPath("/admin/bioelite/ope") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización Bioelite Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('reve-ope') }} className='link-item'>
                            <span>Reve</span>
                            {isOpen('reve-ope') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('reve-ope') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/reve/ope" className={isCurrentPath("/admin/reve/ope") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización Reve Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className='nested-dropdown' id="ope_dz">
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('dz-ope') }} className='link-item'>
                            <span>DZ</span>
                            {isOpen('dz-ope') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('dz-ope') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/dz/ope" className={isCurrentPath("/admin/dz/ope") ? "active" : ""} id="ope_consultar_dz">
                                  <FileText size={16} />
                                  <span>Cotización DZ Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('soporte-ope')} className='link-item'>
                    <span className='link_name'>Ticket de Soporte</span>
                    {isOpen('soporte-ope') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('soporte-ope') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <a href="https://forms.office.com/pages/responsepage.aspx?id=pRffhtXT0kuFU3sNV6O3PBUZyAc4Wx5EiTVlITBFysBUNTRUM0QyRUszN1pSSUFTRlk5WEpIVklBMC4u" target="_blank" rel="noopener noreferrer">
                          <Wrench size={18} />
                          <span>Tickets de Soporte</span>
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('marketing-ase')} className='link-item'>
                    <span className='link_name'>Ticket de Marketing</span>
                    {isOpen('marketing-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('marketing-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing" className={isCurrentPath("/admin/asesor/marketing") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Diseño</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing/eventos" className={isCurrentPath("/admin/asesor/marketing/eventos") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Material (eventos)</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

            </>
          )}

          {isCom && (
            <>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('gestion-com')} className='link-item'>
                    <span className='link_name'>Gestión para Formulas</span>
                    {isOpen('gestion-com') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('gestion-com') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/gestioncomercial" className={isCurrentPath("/admin/gestioncomercial") ? "active" : ""}>
                          <FileText size={18} />
                          <span>Cotización Magistral Derma Nueva</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/gestioncomercials" className={isCurrentPath("/admin/gestioncomercials") ? "active" : ""}>
                          <FlaskConical size={18} />
                          <span>Cotización de Nueva Presentación</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/gestioncomercialss" className={isCurrentPath("/admin/gestioncomercialss") ? "active" : ""}>
                          <FlaskConical size={18} />
                          <span>Cotización de Cambio de Base</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('alta-com')} className='link-item'>
                    <span className='link_name'>Alta Cliente</span>
                    {isOpen('alta-com') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('alta-com') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/altaclientescome" className={isCurrentPath("/admin/altaclientescome") ? "active" : ""}>
                          <FileText size={18} />
                          <span>Alta de clientes</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('soporte-com')} className='link-item'>
                    <span className='link_name'>Ticket de Soporte</span>
                    {isOpen('soporte-com') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('soporte-com') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <a href="https://forms.office.com/pages/responsepage.aspx?id=pRffhtXT0kuFU3sNV6O3PBUZyAc4Wx5EiTVlITBFysBUNTRUM0QyRUszN1pSSUFTRlk5WEpIVklBMC4u" target="_blank" rel="noopener noreferrer">
                          <Wrench size={18} />
                          <span>Tickets de Soporte</span>
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('marketing-ase')} className='link-item'>
                    <span className='link_name'>Ticket de Marketing</span>
                    {isOpen('marketing-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('marketing-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing" className={isCurrentPath("/admin/asesor/marketing") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Diseño</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing/eventos" className={isCurrentPath("/admin/asesor/marketing/eventos") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Material (eventos)</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

            </>
          )}

          {isAtencion && (
            <>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('gestion-atencion')} className='link-item'>
                    <span className='link_name'>Gestión para Fórmulas</span>
                    {isOpen('gestion-atencion') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('gestion-atencion') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('derma-atencion') }} className='link-item'>
                            <span>Derma</span>
                            {isOpen('derma-atencion') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('derma-atencion') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/asesor" className={isCurrentPath("/admin/asesor") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Generar Cotización Magistral Derma Nueva</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/presentacion" className={isCurrentPath("/admin/presentacion") ? "active" : ""}>
                                  <FlaskConical size={16} />
                                  <span>Generar Cotización de Nueva Presentación</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/cambiobase" className={isCurrentPath("/admin/cambiobase") ? "active" : ""}>
                                  <FlaskConical size={16} />
                                  <span>Generar Cotización de Cambio de Base</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('bioequal-atencion') }} className='link-item'>
                            <span>Bioequal</span>
                            {isOpen('bioequal-atencion') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('bioequal-atencion') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioequal/asesor" className={isCurrentPath("/admin/bioequal/asesor") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Generar Cotización Bioequal Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('bioelite-atencion') }} className='link-item'>
                            <span>Bioelite</span>
                            {isOpen('bioelite-atencion') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('bioelite-atencion') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioelite/asesor" className={isCurrentPath("/admin/bioelite/asesor") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización Bioelite Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('alta-atencion')} className='link-item'>
                    <span className='link_name'>Alta Cliente</span>
                    {isOpen('alta-atencion') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('alta-atencion') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/altaclientescome" className={isCurrentPath("/admin/altaclientescome") ? "active" : ""}>
                          <FileText size={18} />
                          <span>Alta de clientes</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('marketing-ase')} className='link-item'>
                    <span className='link_name'>Ticket de Marketing</span>
                    {isOpen('marketing-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('marketing-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing" className={isCurrentPath("/admin/asesor/marketing") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Diseño</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing/eventos" className={isCurrentPath("/admin/asesor/marketing/eventos") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Material (eventos)</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

            </>
          )}

          {isAse && (
            <>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('gestion-ase')} className='link-item'>
                    <span className='link_name'>Gestión para Fórmulas</span>
                    {isOpen('gestion-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('gestion-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <div className='nested-dropdown' >
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('derma-ase') }} className='link-item'>
                            <span>Derma</span>
                            {isOpen('derma-ase') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('derma-ase') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/asesor" className={isCurrentPath("/admin/asesor") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Generar Cotización Magistral Derma Nueva</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/presentacion" className={isCurrentPath("/admin/presentacion") ? "active" : ""}>
                                  <FlaskConical size={16} />
                                  <span>Generar Cotización de Nueva Presentación</span>
                                </Link>
                              </li>
                              <li>
                                <Link onClick={onToggle} to="/admin/cambiobase" className={isCurrentPath("/admin/cambiobase") ? "active" : ""}>
                                  <FlaskConical size={16} />
                                  <span>Generar Cotización de Cambio de Base</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className='nested-dropdown' >
                          <div className='link-item' onClick={(e) => { e.stopPropagation(); toggleDropdown('bioequal-ase') }}>
                            <span>Bioequal</span>
                            {isOpen('bioequal-ase') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('bioequal-ase') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioequal/asesor" className={isCurrentPath("/admin/bioequal/asesor") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Generar Cotización Bioequal Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className='nested-dropdown' >
                          <div className='link-item' onClick={(e) => { e.stopPropagation(); toggleDropdown('bioelite-ase') }}>
                            <span>Bioelite</span>
                            {isOpen('bioelite-ase') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('bioelite-ase') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/bioelite/asesor" className={isCurrentPath("/admin/bioelite/asesor") ? "active" : ""}>
                                  <FileText size={16} />
                                  <span>Cotización Bioelite Nueva</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div className='link-item' onClick={() => toggleDropdown('alta-ase')}>
                    <span className='link_name'>Alta Cliente</span>
                    {isOpen('alta-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('alta-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/altaclientes" className={isCurrentPath("/admin/altaclientes") ? "active" : ""}>
                          <FileText size={18} />
                          <span>Alta de clientes</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              {/**/}
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('soporte-marketing-ase')} className='link-item'>
                    <span className='link_name'>Ticket de Soporte</span>
                    {isOpen('soporte-marketing-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('soporte-marketing-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <a href="https://forms.office.com/pages/responsepage.aspx?id=pRffhtXT0kuFU3sNV6O3PBUZyAc4Wx5EiTVlITBFysBUNTRUM0QyRUszN1pSSUFTRlk5WEpIVklBMC4u" target="_blank" rel="noopener noreferrer">
                          <Wrench size={18} />
                          <span>Tickets de Soporte</span>
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('marketing-ase')} className='link-item'>
                    <span className='link_name'>Ticket de Marketing</span>
                    {isOpen('marketing-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('marketing-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing" className={isCurrentPath("/admin/asesor/marketing") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Diseño</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing/eventos" className={isCurrentPath("/admin/asesor/marketing/eventos") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Material (eventos)</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

            </>
          )}

          {isFN && (
            <>
              <li>
                <div className='dropdown' id="fn_gestion">
                  <div onClick={() => toggleDropdown('gestion-fn')} className='link-item'>
                    <span className='link_name'>Gestión para Fórmulas</span>
                    {isOpen('gestion-fn') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('gestion-fn') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <div className='nested-dropdown' id="fn_reve">
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('reve-fn') }} className='link-item'>
                            <span>Reve</span>
                            {isOpen('reve-fn') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('reve-fn') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/reve/asesor" className={isCurrentPath("/admin/reve/asesor") ? "active" : ""} id="fn_generar_reve">
                                  <FileText size={16} />
                                  <span>Generar solicitud Reve</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className='nested-dropdown' id="fn_dz">
                          <div onClick={(e) => { e.stopPropagation(); toggleDropdown('dz-fn') }} className='link-item'>
                            <span>DZ</span>
                            {isOpen('dz-fn') ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                          </div>
                          {isOpen('dz-fn') && (
                            <ul className='nested-dropdown-menu'>
                              <li>
                                <Link onClick={onToggle} to="/admin/dz/asesor" className={isCurrentPath("/admin/dz/asesor") ? "active" : ""} id="fn_generar_dz">
                                  <FileText size={16} />
                                  <span>Generar solicitud DZ</span>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('marketing-ase')} className='link-item'>
                    <span className='link_name'>Ticket de Marketing</span>
                    {isOpen('marketing-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('marketing-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing" className={isCurrentPath("/admin/asesor/marketing") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Diseño</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing/eventos" className={isCurrentPath("/admin/asesor/marketing/eventos") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Material (eventos)</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

            </>
          )}

          {isConta && (
            <>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('reportes-conta')} className='link-item'>
                    <span className='link_name'>Reportes de Pagos</span>
                    {isOpen('reportes-conta') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('reportes-conta') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/omicronshoppagos" className={isCurrentPath("/admin/omicronshoppagos") ? "active" : ""}>
                          <DollarSign size={18} />
                          <span>Pagos de OmicronShop</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/transaccionescredito" className={isCurrentPath("/admin/transaccionescredito") ? "active" : ""}>
                          <DollarSign size={18} />
                          <span>Transacciones de Crédito</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/clientescreditos" className={isCurrentPath("/admin/clientescreditos") ? "active" : ""}>
                          <DollarSign size={18} />
                          <span>Clientes con Crédito</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/facturapagas" className={isCurrentPath("/admin/facturapagas") ? "active" : ""}>
                          <FileText size={18} />
                          <span>Facturas pagadas</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('soporte-conta')} className='link-item'>
                    <span className='link_name'>Ticket de Soporte</span>
                    {isOpen('soporte-conta') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('soporte-conta') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <a href="https://forms.office.com/pages/responsepage.aspx?id=pRffhtXT0kuFU3sNV6O3PBUZyAc4Wx5EiTVlITBFysBUNTRUM0QyRUszN1pSSUFTRlk5WEpIVklBMC4u" target="_blank" rel="noopener noreferrer">
                          <Wrench size={18} />
                          <span>Tickets de Soporte</span>
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('marketing-ase')} className='link-item'>
                    <span className='link_name'>Ticket de Marketing</span>
                    {isOpen('marketing-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('marketing-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing" className={isCurrentPath("/admin/asesor/marketing") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Diseño</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing/eventos" className={isCurrentPath("/admin/asesor/marketing/eventos") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Material (eventos)</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

            </>
          )}

          {isMarket && (
            <>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('reportes-market')} className='link-item'>
                    <span className='link_name'>Reportes de Pagos</span>
                    {isOpen('reportes-market') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('reportes-market') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/MarkCatPromos" className={isCurrentPath("/admin/MarkCatPromos") ? "active" : ""}>
                          <DollarSign size={18} />
                          <span>Información de Códigos Promocionales</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/Markfacturas" className={isCurrentPath("/admin/Markfacturas") ? "active" : ""}>
                          <DollarSign size={18} />
                          <span>Facturas de SAP</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/Markpromos" className={isCurrentPath("/admin/Markpromos") ? "active" : ""}>
                          <DollarSign size={18} />
                          <span>Transacciones con Código Promocional</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('soporte-market')} className='link-item'>
                    <span className='link_name'>Ticket de Soporte</span>
                    {isOpen('soporte-market') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('soporte-market') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <a href="https://forms.office.com/pages/responsepage.aspx?id=pRffhtXT0kuFU3sNV6O3PBUZyAc4Wx5EiTVlITBFysBUNTRUM0QyRUszN1pSSUFTRlk5WEpIVklBMC4u" target="_blank" rel="noopener noreferrer">
                          <Wrench size={18} />
                          <span>Tickets de Soporte</span>
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

              <li>
                <div className='dropdown' >
                  <div onClick={() => toggleDropdown('marketing-ase')} className='link-item'>
                    <span className='link_name'>Ticket de Marketing</span>
                    {isOpen('marketing-ase') ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </div>
                  {isOpen('marketing-ase') && (
                    <ul className='dropdown-menu'>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing" className={isCurrentPath("/admin/asesor/marketing") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Diseño</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={onToggle} to="/admin/asesor/marketing/eventos" className={isCurrentPath("/admin/asesor/marketing/eventos") ? "active" : ""}>
                          <Wrench size={18} />
                          <span>Ticket Material (eventos)</span>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </li>

            </>
          )}
        </ul>
        <div className='profile-section'>
          <img
            src={imagenUrl}
            alt="Profile"
            className="profile-image"
            onClick={onPerfil}

          />
          <span onClick={onPerfil}>
            {Nombre} {Apellido}
          </span>
          <div
            className="logout-icon"
            onClick={onLogout}
            title="Cerrar Sesión"
          >
            <LogOut size={20} />
          </div>
        </div>
      </div>
    </>
  )
}